import React from 'react';
import { GlassCard } from '../../_shared/GlassCard';
import { XCircle, CheckCircle } from 'lucide-react';

const beforePoints = [
    '676 followers, low discoverability',
    '~15K views, not surfaced by algorithm',
    '~6.4K reach, barely beyond existing audience',
    'No keyword-optimized hooks or captions',
    'Inconsistent posting cadence',
];

const afterPoints = [
    '2,160 followers, 220% growth rate',
    '830K+ total views, algorithm actively pushing content',
    '16,265 avg reach, 2.5× more people',
    'SEO-optimized hooks with yellow & white text',
    '9 top-performing reels, each 38K to 142K views',
];

export const BeforeAfter = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-5xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Before vs After</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
                    The Social SEO Impact
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative">
                    {/* Before card */}
                    <GlassCard className="border-red-500/20">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="p-2.5 rounded-xl bg-red-500/15">
                                <XCircle size={20} className="text-red-400" />
                            </div>
                            <h3 className="text-lg font-bold text-red-300">Before Social SEO</h3>
                        </div>
                        <div className="space-y-4">
                            {beforePoints.map((point, i) => (
                                <div key={i} className="flex items-start gap-3">
                                    <span className="w-1.5 h-1.5 rounded-full bg-red-400/60 mt-2 flex-shrink-0" />
                                    <p className="text-white/60 text-sm leading-relaxed">{point}</p>
                                </div>
                            ))}
                        </div>
                    </GlassCard>

                    {/* VS divider (desktop) */}
                    <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
                        <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-xl border border-white/20 flex items-center justify-center">
                            <span className="text-white font-black text-sm">VS</span>
                        </div>
                    </div>

                    {/* After card */}
                    <GlassCard className="border-emerald-500/20">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="p-2.5 rounded-xl bg-emerald-500/15">
                                <CheckCircle size={20} className="text-emerald-400" />
                            </div>
                            <h3 className="text-lg font-bold text-emerald-300">After Social SEO</h3>
                        </div>
                        <div className="space-y-4">
                            {afterPoints.map((point, i) => (
                                <div key={i} className="flex items-start gap-3">
                                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400/60 mt-2 flex-shrink-0" />
                                    <p className="text-white/60 text-sm leading-relaxed">{point}</p>
                                </div>
                            ))}
                        </div>
                    </GlassCard>
                </div>
            </div>
        </section>
    );
};
